import React, {useEffect, useState} from 'react';
import './Login.css';
import logoImage from '../../assets/eucomex-logo.png';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import useLoginForm from "../../hooks/useLoginForm";
import 'react-toastify/dist/ReactToastify.css';
import {useNavigate} from 'react-router-dom';
import {useAuthContext} from "../../context/AuthProvider";

const Login = () => {
    const {
        username,
        setUsername,
        password,
        setPassword,
        isSubmitting,
        handleSubmit,
    } = useLoginForm();

    const {role} = useAuthContext()

    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
    };

    const handleFormSubmit = async (e: any) => {
        await handleSubmit(e);
    };

    useEffect(() => {
        if (role) {
            navigate(`/${role}/home`);
        }
    }, [role,navigate]);

    return (
        <div className="login-container">
            {isSubmitting && (
                <div className="spinner-overlay">
                    <LoadingSpinner/>
                </div>
            )}
            <img src={logoImage} alt="Logo" className="login-logo"/>
            <div className="login-card">
                <h1>Plataforma de Trabajo</h1>
                <h3>Inicio de sesión</h3>
                <br/>
                <form onSubmit={handleFormSubmit}>
                    <div className="form-group">
                        <label>Nombre de usuario</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Ingresa tu usuario"
                        />
                    </div>
                    <div className="form-group">
                        <label>Contraseña</label>
                        <div className="password-container">
                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Ingresa tu contraseña"
                            />
                            <button
                                type="button"
                                className="password-toggle-button"
                                onClick={togglePasswordVisibility}
                            >
                                <span className="material-icons">
                                    {showPassword ? 'visibility_off' : 'visibility'}
                                </span>
                            </button>
                        </div>
                    </div>
                    <button
                        type="submit"
                        className="login-button"
                        disabled={isSubmitting}
                    >
                        Iniciar sesión
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
